export default "__VITE_ASSET__DEChf82I__"